import Alpine from "alpinejs";
import { rafInterval, rafTimeOut } from "./requestAnimationFrame";

Alpine.magic("rafTimeOut", (el, { cleanup }) => (callback, delay) => {
    const timeout = rafTimeOut(callback, delay);
    cleanup(() => timeout.clear());
    return timeout;
});

Alpine.magic("rafInterval", (el, { cleanup }) => (callback, delay) => {
    const interval = rafInterval(callback, delay);
    cleanup(() => interval.clear());
    return interval;
});
